import { render, staticRenderFns } from "./TemperatureGauge.vue?vue&type=template&id=80cebf1e&scoped=true&"
import script from "./TemperatureGauge.vue?vue&type=script&lang=js&"
export * from "./TemperatureGauge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80cebf1e",
  null
  
)

export default component.exports